









import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FontLoader extends Vue {
  private get useAllFonts() { return !!this.$route.query.useAllFonts }
}
